import React, { Component } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  Box, 
  Typography,
  Divider,
  IconButton,
  Chip,
  Slide,
  Zoom,
  Alert
} from '@mui/material';
import { 
  Close, 
  AddShoppingCart, 
  Euro, 
  MonitorWeight,
  CheckCircle,
  Add,
  Remove,
  ShoppingCart,
  Warning
} from '@mui/icons-material';

import ClientAPI from '../service/ClientAPI';
import Events from '../service/Events';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ChooseProductPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      amount: 1,
      isAdding: false,
      showSuccess: false,
      existingOrders: [],
      hasConfirmedOrder: false,
      totalExistingAmount: 0,
      unconfirmedAmount: 0,
      confirmedAmount: 0,
      totalExistingCost: null
    };
  }

  handleShow = (title) => this.setState({ show: true, title });

  handleClose = () => {
    this.setState({ show: false, showSuccess: false });
    this.props.onClose();
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    
    this.setState({ isAdding: true });

    ClientAPI.SelectProduct(this.props.product.ID, this.state.amount)
      .then((_res) => {
        // Show success animation
        this.setState({ 
          showSuccess: true,
          isAdding: false 
        });

        Events.onResult.emit("success", "Die Produkte wurden hinzugefügt!");

        // Close after animation
        setTimeout(() => {
          this.handleClose();
        }, 1200);
      })
      .catch((err) => {
        console.error(err);
        this.setState({ isAdding: false });
      });
  }

  componentDidUpdate(prevProps) {
    if (this.state.show !== this.props.show && this.props.show) {
      // Fetch existing orders when popup opens
      this.fetchExistingOrders();
      
      this.setState({ 
        show: this.props.show, 
        amount: 1,
        showSuccess: false
      });
    }
  }

  fetchExistingOrders = () => {
    const { product } = this.props;
    if (!product) return;

    ClientAPI.GetOrders()
      .then((orders) => {
        // Filter orders for this specific product
        const productOrders = orders.filter(order => order.productID === product.ID);
        const confirmedOrder = productOrders.find(order => order.Confirmed);
        const unconfirmedOrders = productOrders.filter(order => !order.Confirmed);
        
        const totalAmount = productOrders.reduce((sum, order) => sum + order.Amount, 0);
        const unconfirmedAmount = unconfirmedOrders.reduce((sum, order) => sum + order.Amount, 0);
        const confirmedAmount = totalAmount - unconfirmedAmount;
        
        // Calculate total cost if product has fixed price
        const totalCost = product.isFixed ? productOrders.reduce((sum, order) => {
          return sum + (order.Amount * (order.Price !== null ? order.Price : product.Price));
        }, 0) : null;

        this.setState({
          existingOrders: productOrders,
          hasConfirmedOrder: confirmedOrder !== undefined,
          totalExistingAmount: totalAmount,
          unconfirmedAmount,
          confirmedAmount,
          totalExistingCost: totalCost
        });
      })
      .catch(console.error);
  }

  handleChangeAmount = (newAmount) => {
    if (newAmount >= 1) {
      this.setState({ amount: newAmount });
    }
  }

  render() {
    const { product } = this.props;
    const { 
      amount, 
      showSuccess, 
      isAdding, 
      hasConfirmedOrder, 
      totalExistingAmount, 
      unconfirmedAmount,
      confirmedAmount,
      totalExistingCost,
      existingOrders 
    } = this.state;

    if (!product) return null;

    const totalPrice = product.isFixed ? (amount * product.Price).toFixed(2) : null;
    const isDisabled = hasConfirmedOrder || isAdding;

    return (
      <Dialog
        open={this.state.show}
        onClose={this.handleClose}
        TransitionComponent={Transition}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: '12px', sm: '20px' },
            position: 'relative',
            overflow: 'visible',
            margin: { xs: '16px', sm: '32px' },
            maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
          }
        }}
      >
        {/* Success Overlay */}
        {showSuccess ? (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bgcolor: 'rgba(46, 125, 50, 0.95)',
              zIndex: 9999,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '20px',
              animation: 'fadeIn 0.3s ease-out',
              '@keyframes fadeIn': {
                '0%': { 
                  opacity: 0
                },
                '100%': { 
                  opacity: 1
                }
              }
            }}
          >
            <Zoom in={showSuccess}>
              <CheckCircle 
                sx={{ 
                  fontSize: '120px', 
                  color: 'white',
                  animation: 'bounce 0.6s ease-out',
                  '@keyframes bounce': {
                    '0%, 100%': { transform: 'scale(1)' },
                    '25%': { transform: 'scale(0.9)' },
                    '50%': { transform: 'scale(1.15)' },
                    '75%': { transform: 'scale(0.95)' }
                  }
                }} 
              />
            </Zoom>
            <Typography 
              variant="h4" 
              sx={{ 
                color: 'white', 
                fontWeight: 700, 
                mt: 2,
                animation: 'slideUp 0.5s ease-out 0.2s both',
                '@keyframes slideUp': {
                  '0%': { 
                    opacity: 0, 
                    transform: 'translateY(20px)' 
                  },
                  '100%': { 
                    opacity: 1, 
                    transform: 'translateY(0)' 
                  }
                }
              }}
            >
              Hinzugefügt!
            </Typography>
          </Box>
        ) : <></>}

        {/* Close Button */}
        <IconButton
          onClick={this.handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#666',
            zIndex: 1
          }}
        >
          <Close />
        </IconButton>

        {/* Header with gradient */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
            pt: { xs: 3, sm: 4 },
            pb: { xs: 2.5, sm: 3 },
            px: { xs: 2, sm: 3 },
            color: 'white'
          }}
        >
          <DialogTitle sx={{ p: 0, mb: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
              {product.Name}
            </Typography>
          </DialogTitle>
          
          {/* Product Info Cards */}
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 2 }}>
            <Box
              sx={{
                flex: 1,
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                borderRadius: '12px',
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <Euro sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
              <Box>
                <Typography variant="caption" sx={{ opacity: 0.9, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}>
                  PREIS
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                  {product.isFixed ? `${product.Price}€` : 'Nach Bestätigung'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                borderRadius: '12px',
                p: 2,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <MonitorWeight sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
              <Box>
                <Typography variant="caption" sx={{ opacity: 0.9, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}>
                  GEWICHT
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                  {product.isFixed ? `${product.Weight} Kg/L` : 'Nach Bestätigung'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
          <form onSubmit={this.handleSubmit}>
            {/* Confirmed Order Warning */}
            {hasConfirmedOrder ? (
              <Box sx={{ mb: 3 }}>
                <Alert 
                  severity="warning"
                  icon={<Warning />}
                  sx={{ 
                    borderRadius: '12px',
                    '& .MuiAlert-message': { width: '100%' }
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    ⚠️ Bereits bestätigt!
                  </Typography>
                  <Typography variant="body2">
                    Sie haben bereits <strong>{confirmedAmount}x</strong> dieses Produkts bestätigt.
                    {product.isFixed && totalExistingCost ? (
                      <span> (Gesamtwert: <strong>{totalExistingCost.toFixed(2)}€</strong>)</span>
                    ) : <></>}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 600, color: '#d32f2f' }}>
                    Sie können keine weiteren Bestellungen für dieses Produkt hinzufügen.
                  </Typography>
                </Alert>
              </Box>
            ) : <></>}

            {/* Unconfirmed Items in Cart Info */}
            {unconfirmedAmount > 0 && !hasConfirmedOrder ? (
              <Box sx={{ mb: 3 }}>
                <Alert 
                  severity="info"
                  icon={<ShoppingCart />}
                  sx={{ 
                    borderRadius: '12px',
                    '& .MuiAlert-message': { width: '100%' }
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Im Warenkorb
                  </Typography>
                  <Typography variant="body2">
                    Sie haben bereits <strong>{unconfirmedAmount}x</strong> dieses Produkts in Ihrem Warenkorb
                    {existingOrders.length > 1 ? ` (${existingOrders.length} Bestellung${existingOrders.length > 1 ? 'en' : ''})` : <></>}.
                  </Typography>
                  {product.isFixed && totalExistingCost ? (
                    <Box sx={{ 
                      mt: 1.5, 
                      pt: 1.5, 
                      borderTop: '1px solid rgba(0,0,0,0.1)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Aktueller Gesamtwert:
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 700, color: '#1976d2' }}>
                        {totalExistingCost.toFixed(2)}€
                      </Typography>
                    </Box>
                  ) : <></>}
                </Alert>
              </Box>
            ) : <></>}

            {/* Amount Selector */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600, color: '#333' }}>
                Anzahl auswählen
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <IconButton
                  onClick={() => this.handleChangeAmount(amount - 1)}
                  disabled={amount <= 1 || hasConfirmedOrder}
                  sx={{
                    bgcolor: '#f5f5f5',
                    '&:hover': { bgcolor: '#e0e0e0' },
                    '&.Mui-disabled': { bgcolor: '#fafafa' }
                  }}
                >
                  <Remove />
                </IconButton>

                <TextField
                  type="number"
                  value={amount}
                  onChange={(e) => this.handleChangeAmount(parseInt(e.target.value) || 1)}
                  disabled={hasConfirmedOrder}
                  inputProps={{ min: 1, style: { textAlign: 'center', fontSize: '1.5rem', fontWeight: 600 } }}
                  sx={{
                    width: '120px',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '12px',
                      bgcolor: hasConfirmedOrder ? '#fafafa' : '#f8f9fa'
                    }
                  }}
                />

                <IconButton
                  onClick={() => this.handleChangeAmount(amount + 1)}
                  disabled={hasConfirmedOrder}
                  sx={{
                    bgcolor: '#2e7d32',
                    color: 'white',
                    '&:hover': { bgcolor: '#1b5e20' },
                    '&.Mui-disabled': { bgcolor: '#e0e0e0', color: '#9e9e9e' }
                  }}
                >
                  <Add />
                </IconButton>
              </Box>
            </Box>

            {/* Total Price Display */}
            {product.isFixed ? (
              <Box
                sx={{
                  bgcolor: '#e8f5e9',
                  borderRadius: '12px',
                  p: 2.5,
                  border: '2px solid #2e7d32',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1b5e20' }}>
                  Gesamtpreis
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                  {totalPrice}€
                </Typography>
              </Box>
            ) : <></>}
          </form>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ 
          p: { xs: 2, sm: 3 }, 
          gap: { xs: 1.5, sm: 2 },
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <Button
            onClick={this.handleClose}
            variant="outlined"
            size="large"
            fullWidth
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#ddd',
              color: '#666',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              py: { xs: 1.2, sm: 1.5 },
              order: { xs: 2, sm: 1 },
              '&:hover': {
                borderColor: '#bbb',
                bgcolor: '#f5f5f5'
              }
            }}
          >
            Abbrechen
          </Button>
          <Button
            onClick={this.handleSubmit}
            variant="contained"
            size="large"
            fullWidth
            startIcon={hasConfirmedOrder ? <Warning /> : <AddShoppingCart />}
            disabled={isDisabled}
            sx={{
              bgcolor: hasConfirmedOrder ? '#9e9e9e' : '#2e7d32',
              color: 'white',
              fontWeight: 600,
              textTransform: 'none',
              fontSize: { xs: '0.9rem', sm: '1.1rem' },
              py: { xs: 1.2, sm: 1.5 },
              borderRadius: '10px',
              boxShadow: hasConfirmedOrder ? 'none' : '0 4px 12px rgba(46, 125, 50, 0.3)',
              order: { xs: 1, sm: 2 },
              '&:hover:not(:disabled)': {
                bgcolor: '#1b5e20',
                boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                transform: 'translateY(-2px)'
              },
              transition: 'all 0.2s ease',
              '&.Mui-disabled': {
                bgcolor: '#9e9e9e',
                color: 'white'
              }
            }}
          >
            {hasConfirmedOrder ? 'Bereits bestätigt' : isAdding ? 'Wird hinzugefügt...' : 'In den Warenkorb'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ChooseProductPopup;